import { get } from "lodash";
import { processUserProfile } from "./userProfile"

export const processSales = (rawData)=>{
    return {
        ...processUserProfile(rawData),
        isMainSale: Boolean(get(rawData, 'isMainSale')),
        reportTo: get(rawData, ':reportTo'),
    };
}